<template>
  <div
    v-if="!isDismissed"
    :class="componentClass"
    class="p-3 border  transition-colors duration-150"
  >
    <level>
      <div class="flex flex-nowrap items-center gap-2">
        <icon v-if="icon" :path="icon" w="w-5" h="h-5" size="24"/>
        <span class="text-center md:text-left"><slot /></span>
      </div>
      <slot v-if="hasRightSlot" name="right" />
    </level>
  </div>
</template>

<script>
import { ref, computed } from 'vue'
import { useStore } from 'vuex'
import { mdiClose } from '@mdi/js'
import { colorsBg, colorsBorders, colorsOutline } from '@/colors.js'
import Level from '@/components/Level'
import Icon from '@/components/Icon'

export default {
  name: 'Notification',
  components: {
    Icon,
    Level
  },
  props: {
    icon: String,
    outline: Boolean,
    color: {
      type: String,
      required: true
    }
  },
  setup (props, { slots }) {
    const componentClass = computed(() => props.outline
      ? colorsOutline[props.color]
      : [...colorsBg[props.color], ...colorsBorders[props.color]])

    const isDismissed = ref(false)

    const dismiss = () => {
      isDismissed.value = true
    }

    const hasRightSlot = computed(() => slots.right)

    const store = useStore()

    const darkMode = computed(() => store.state.darkMode)

    return {
      componentClass,
      isDismissed,
      dismiss,
      hasRightSlot,
      darkMode,
      mdiClose
    }
  }
}
</script>
